import { useQueryClient } from '@tanstack/react-query';
import { getAllDocuments } from '@api/services/box-storage.service';
import useDataQuery from '@hooks/use-data-query';

export const useDocumentListData = () => {
    const queryKey = ['documents'];
    const queryClient = useQueryClient();

    const documentListQuery = useDataQuery(queryKey, () => getAllDocuments());

    const setData = (updater: (prev: any) => any) => {
        queryClient.setQueryData(queryKey, updater);
    };

    return {
        documentList: documentListQuery.data,
        isLoading: documentListQuery.isLoading,
        setData,
    };
};
